module.exports = __webpack_public_path__ + "static/Embajada-f267a2b9f9c71fe9f7163b4baf83359a.jpg";